<template>
  <nav class="nav-menu2-vpos">
    <div class="d-flex justify-content-between">
      <div class="d-flex justify-content-center w-50">
        <a  class="w-25 title m-auto" style="font-family: system-ui; color: white;" href="/vpos">
         {{ currentLanguage.header_menuCuaHang }}</a
        >

        <input
          class="m-auto input-search"
          type="search"
          name=""
          placeholder="Tìm kiếm cửa hàng..."
        />
        <button class="btn-search">
          <i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
      <div class="d-flex w-25">
        <!-- <div class="m-auto">
          <input  type="checkbox"     v-model="chungChecked"    @change="updateChecked()"   />
          <span class="p-2"> Chung</span>
        </div>
        <div class="m-auto"> nb
          <input  type="checkbox"  v-model="riengChecked"    @change="updateChecked()"  />
          <span class="p-2"> Riêng</span>
        </div> -->
        <div class="m-auto">
          <div class="dropdown flex-column d-flex">
            <span class="dropbtn ">
              
              <img :src="imageUrls.iconTyGia" /> {{ currentLanguage.header_TyGia }}
            </span>
            <span style="font-size: 11px;"> {{ viewTyGia }} </span>
            <div class="dropdown-content mt-5">
              <button class="w-100" @click="layTyGia()" style="border: none; height: 35px; background: cadetblue;">{{ currentLanguage.titleCapNhat }} </button>
              <span
                class="p-2 d-flex justify-content-sm-center"
                style="font-size: 16px; color: black"
                >{{ currentLanguage.capNhapTyGia }} : {{ timeUpdateTyGia }}
              </span>
              <a style="color: black;"
                @click="changeLanguage('vi')"
                ><div class="d-flex">
                  <!-- <img :src="getCurrencyImage(item.currency)" /> -->
                  <div class="d-flex  w-100 " style="margin-left: 20px">
                    <div class="w-50 d-flex flex-column" style="border-right: 1px burlywood solid;"> 
                   <span style="font-weight: 600">
                    VND
                    </span> 
                    <span n style="font-weight: 100">
                   VIỆT NAM ĐỒNG
                    </span> 
                  </div>                  
                  <div class="w-50 m-auto">
                    <span > 0 đ</span
                    >
                  </div>
                </div>
                </div></a
              >
              <a
              style="color: black;"
                v-for="(item, index) in tyGiaNgoaiTe"
                :key="index"
                @click="changeLanguage(getLanguage(item))"
                ><div class="d-flex">
                  <!-- <img :src="getCurrencyImage(item.currency)" /> -->
                  <div class="d-flex  w-100 " style="margin-left: 20px">
                    <div class="w-50 d-flex flex-column" style="border-right: 1px burlywood solid;"> 
                   <span style="font-weight: 600">
                      {{ item.currency }} 
                    </span> 
                    <span n style="font-weight: 100">
                      {{ item.name }} 
                    </span> 
                  </div>                  
                  <div class="w-50 m-auto">
                    <span
                      >1 {{ item.kyHieu }} =
                      {{ formattedPrice(item.muaCK) }} đ</span
                    >
                  </div>
                  
                </div>
                </div></a
              >
            </div>
          </div>
        </div>
        <div class="m-auto">
          <a class="" style="font-size: 18px; color: white">
            <i class="fa fa-bell-o" aria-hidden="true"></i
          ></a>
        </div>

        <div class="m-auto" v-if="Login">
          <span
            class=""
            style="color: white; cursor: pointer"
            data-toggle="modal"
            data-target="#exampleModalCenter"
          >
            <i class="fa fa-user-circle-o" aria-hidden="true"></i>{{ currentLanguage.header_DangNhap }}</span
          >
        </div>
      </div>
      <!-- <div class="d-flex  dropdown" v-if="menuThongTin">
        <div class="d-flex align-items-center dropdown">
          <div class="text-color-white choose_menu dropbtn">
            <img
              class="rounded-circle"
              :src="imageUrls.urlAnh + avatar"
              style="width: 30px; height: 30px"
            />
            <span class="ms-md-1 fs-Acc_name max-text">{{ name }}</span>
          </div>
          <div class="dropdown-content">
           <main-menu-vpos></main-menu-vpos>
          </div>
        </div>
      </div> -->

      <div class="" v-if="menuThongTin">
        <div class="dropdown">
          <div class="text-color-white choose_menu dropbtn">
            <img
              class="rounded-circle"
              :src="imageUrls.urlAnh + avatar"
              style="width: 30px; height: 30px"
            />
            <span class="ms-md-1 fs-Acc_name max-text">{{ name }}</span>
          </div>
          <div class="dropdown-content">
            <main-menu-vpos></main-menu-vpos>
          </div>
        </div>
      </div>

      <div class="menu_right" style="display: flex">
        <a @click="changeLanguage('vi')" class="lang" style="padding: 5px"
          ><img src="img/img-item-vimass-2022/co/vi-VN.gif" />
        </a>
        <a @click="changeLanguage('en')" class="lang" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/us.png" />
        </a>
        <a @click="changeLanguage('cn')" class="lang" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/cn.jpg" />
        </a>
        <a @click="changeLanguage('en')" class="lang" style="padding: 5px"
          ><img
            style="width: 25px"
            src="https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_jpy.svg?h=32&w=32&ts=20230610195953&hash=C5D3E7B6B5EEE49C3D5C3C3A8B6798B8"
          />
        </a>
        <a @click="changeLanguage('en')" class="lang" style="padding: 5px"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/kr.jpg" />
        </a>

        <!-- <a onclick="changeLang('hi')" class="lang"
          ><img style="width: 25px" src="img/img-item-vimass-2022/co/hi.png" />
        </a> -->
        <span
          class="clickShow"
          style="color: #ffffff; cursor: pointer; margin: auto; padding: 5px"
          ><i class="fa fa-ellipsis-h" aria-hidden="true"></i
        ></span>
        <div class="showCo" style="display: none; margin: auto">
          <a onclick="changeLang('us')" class="lang"
            ><img src="img/img-item-vimass-2022/co/indo.jpg" />
          </a>
          <a onclick="changeLang('us')" class="lang"
            ><img src="img/img-item-vimass-2022/co/tl.png" />
          </a>
          <a onclick="changeLang('us')" class="lang"
            ><img src="img/img-item-vimass-2022/co/thailan.png" />
          </a>
          <a onclick="changeLang('us')" class="lang"
            ><img src="img/img-item-vimass-2022/co/hu.jpg" />
          </a>
        </div>
        <a id="urlHome" @click="chuyenHome()" style="margin: 0 10px"
          ><img
            style="width: 35px; height: 35px"
            src="img/home-icon-white-8.jpg"
          />
        </a>
      </div>
    </div>
  </nav>
  <div
    class="modal fade"
    id="exampleModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" style="border-radius: 15px">
        <vpos-login></vpos-login>
      </div>
    </div>
  </div>
</template>
<script>
import { imageUrls } from "@/components/js/urlImg";

import { languages } from "@/components/js/langVpos";
import { postLayTiGia } from "@/components/js/VposServiceDanh";
import VposLogin from "../../Accounts/VposLogin.vue";
import MainMenuVpos from "../MainMenuVpos.vue";
import { KEY_CHONTYGIA } from '@/components/js/VposService';
//  import store from "@/components/js/store/index";
export default {
  components: { VposLogin, MainMenuVpos },
  data() {
    return {
      imageUrls: imageUrls,
      currentLanguage: languages.vi,
      Login: true,
      menuThongTin: false,
      register: false,
      user: "",
      listCuaHang: [],
      bannerQuangCao: true,
      myStore: false,
      name: "",
      email: "",
      avatar: "",
      lang:"",
      phone: "",
      timeUpdateTyGia: "",
      tyGiaNgoaiTe: [
        {
          iconCo:
            "https://www.vietcombank.com.vn/-/media/Default-Website/Default-images/Icons/Language/VIE.png?db=web",
          maNgoaiTe: "VND",
          ngonNgu: "Tiếng Việt",
          tyGia: "",
        },
        {
          iconCo:
            "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_usa.svg?h=32&w=32&ts=20230610195953&hash=4576D9B7C910424CC72B7A592BA369AE",
          maNgoaiTe: "USD",
          ngonNgu: "English",
          tyGia: "1 USD = 25,485.00 VND",
        },
        {
          iconCo:
            "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_eur.svg?h=32&w=32&ts=20230610195955&hash=10502813C2316A5601FD57F7A0C89A3A",
          maNgoaiTe: "EUR",
          ngonNgu: "English",
          tyGia: "1 USD = 27,860.08 VND",
        },
      ],
      currencyImages: {
        USD: "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_usa.svg?h=32&w=32&ts=20230610195953&hash=4576D9B7C910424CC72B7A592BA369AE",
        EUR: "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_eur.svg?h=32&w=32&ts=20230610195955&hash=10502813C2316A5601FD57F7A0C89A3A",
        CNY: "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_cny.svg?h=32&w=32&ts=20230610195953&hash=1E37E5E1D30CA9F186D9B8A0A188AE7C",
        JPY: "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_jpy.svg?h=32&w=32&ts=20230610195953&hash=C5D3E7B6B5EEE49C3D5C3C3A8B6798B8",
        KRW: "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_krw.svg?h=32&w=32&ts=20230709003433&hash=43B80AF8FF6632988EB89EF0C30BDDE6",
        // Thêm các ánh xạ tiền tệ và đường dẫn hình ảnh ở đây...
      },
      ngonNgu: {
        USD: "English",
        EUR: "English",
        CNY: "中国人",
        JPY: "日本語",
        KRW: "한국인",
        // Thêm các ánh xạ tiền tệ và đường dẫn hình ảnh ở đây...
      },
      viewTyGia:""
    };
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    // const lang = this.$route.params.lang;
    this.lang= savedLanguage;
    if (languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }

    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  computed: {
    sortedCurrencies() {
      const order = ["USD", "EUR", "CNY", "KRW", "JPY"]; // Thứ tự mong muốn
      return this.tyGiaNgoaiTe.slice().sort((a, b) => {
        return order.indexOf(a.currency) - order.indexOf(b.currency);
      });
    },
    filteredCurrencies() {
      const order = ["USD", "EUR", "CNY", "KRW", "JPY"]; // Thứ tự mong muốn
      const sortedCurrencies = this.tyGiaNgoaiTe.slice().sort((a, b) => {
        return order.indexOf(a.currency) - order.indexOf(b.currency);
      });
      const filteredCurrencies = sortedCurrencies.filter((currency) =>
        order.includes(currency.currency)
      );
      const remainingCurrencies = this.tyGiaNgoaiTe.filter(
        (currency) => !order.includes(currency.currency)
      );
      return filteredCurrencies.concat(remainingCurrencies);
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
  },
  mounted() {
    this.checkLogin();
    this.handleDataReceived();
    this.layTyGia();
    this.getUser();
    if(this.lang == 'vi'){
      this.viewTyGia = "";
    }else{
        this.viewTyGia =  KEY_CHONTYGIA 
    }
 
  },

  methods: {
    getLanguage(item) {
      localStorage.setItem("objTyGia", item);
      var chonTyGia = "1 " + item.kyHieu + " = "+  item.muaCK.toLocaleString() +" đ";
      localStorage.setItem("chonTyGia", chonTyGia)
    switch(item.currency) {
      case 'USD':
      case 'EUR':
        return 'en';
      case 'CNY':
        return 'cn';
        case 'JPY':
        return 'en';
        case 'KRW':
        return 'kr';
      default:
        return 'en';
    }
  },
    chuyenHome(){
this.$router.push("/"+this.lang)
    },
    getCurrencyImage(currency) {
      return this.currencyImages[currency];
    },
    getNgonNgu(currency) {
      return this.ngonNgu[currency];
    },

    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },
    formattedPrice(tyGiaVND) {
      if (tyGiaVND !== undefined && tyGiaVND !== null) {
    return tyGiaVND.toLocaleString();
  } else {
    return ''; // Hoặc giá trị mặc định khác phù hợp với ứng dụng của bạn
  }
    },
    async layTyGia() {
      const res = await postLayTiGia();
      this.tyGiaNgoaiTe = res.result.currency;
      // console.table(res.result.currency);
      this.timeUpdateTyGia = res.result.timeS;
    },
    checkLogin() {
      this.user = localStorage.getItem("user");
      if (this.user == "" || this.user == null) {
        this.Login = true;
        this.menuThongTin = false;
      } else {
        this.menuThongTin = true;
        this.Login = false;
      }
    },
    handleDataReceived() {
      var data = localStorage.getItem("dataCuaHang");
      this.listCuaHang = JSON.parse(data);
    },
    async getUser() {
      const dataFromLocalStorage = localStorage.getItem("user");
      if (dataFromLocalStorage) {
        try {
          const parsedData = JSON.parse(dataFromLocalStorage);
          this.name = parsedData.nameAlias;
          this.avatar = parsedData.avatar;
          this.phone = parsedData.phone;
          this.email = parsedData.email;
        } catch (error) {
          console.error("Error parsing data from localStorage:", error);
        }
      } else {
        console.warn("No data found in localStorage");
      }
    },
  },
};
</script>
<style>
.dropbtn {
  background-color: #007abb;
  color: white;
  border: none;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: white !important;
  border-radius: 10px;
  box-shadow: 0px 8px 16px 0px rgba(200, 200, 200, 0.2);
  z-index: 1;
  left: -120px;
  height: 500px;
  overflow: auto;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  border-bottom: 1px #b4b7b9 solid;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: #007abb !important;
}
</style>